import { jsx } from "react/jsx-runtime";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { validateTidalLicense } from "../../base/index.js";
function Dashboard(props) {
  return /* @__PURE__ */ jsx(
    DashboardIcon,
    {
      "data-testid": "Dashboard",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Dashboard",
      "data-tidal-icon-meta": "common,navigation"
    }
  );
}
Dashboard.tidalIconMeta = {
  categories: "common,navigation",
  name: "Dashboard"
};
validateTidalLicense();
export {
  Dashboard
};
//# sourceMappingURL=Dashboard.js.map
